(function () {
  // On product pages, try use pattern collections to auto select variants
  // Eg. /collections/xxxxx/products/bestie-backpack/
  if (document.body.classList.contains('template-product')) {
    // get pattern
    const paths = window.location.pathname.split('/');
    let prev = false;
    let pattern = false;
    paths.forEach(function (path) {
      if (prev === 'collections') {
        pattern = path.toLowerCase().split('-');
      }
      prev = path;
    });

    // When the product was not reached through a collection, pattern stays false and no
    // words are compared, so the first swatch matches by default and gets selected. That
    // is what the previous jQuery version did — $.each(false, …) iterated nothing and left
    // wordsMatch true — so it is preserved here deliberately rather than guarded away.
    const patternWords = Array.isArray(pattern) ? pattern : [];

    // check pattern exists in swatches
    const swatches = document.querySelectorAll('.ColorSwatchList label');
    for (let i = 0; i < swatches.length; i++) {
      const swatch = swatches[i];
      const tooltip = swatch.dataset.tooltip;
      if (!tooltip) {
        continue;
      }
      const title = tooltip.toLowerCase().split(' ');
      const wordsMatch = patternWords.every(function (word) {
        return title.indexOf(word) !== -1;
      });
      if (wordsMatch) {
        swatch.click();
        break;
      }
    }
  }

  // Holding page height
  function setAppHeight() {
    document.body.style.setProperty('--app-height', `${window.innerHeight}px`);
  }

  window.addEventListener('resize', setAppHeight);
  setAppHeight();
})();
